import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 获取售卖课程
export const getRoomCart = (params) =>
  request(`${mock}/v1/roomCart/get`, "get", { params });
// 获取所有售卖
export const getRoomCartAll = (params) =>
  request(`${mock}/v1/roomCart/getAll`, "get", { params });
